const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const init = () => {
  const content = { module:'content4',content:'member'}
  $(()=>{
    resolve()
  })
  $.when(
    $.getArticle(content),
  ).done(items => {
    const is_list = document.body.classList.contains('is--list');
    if (is_list) {
      member_list(items)
    } else {
      article_info(items,location.search.replace(/.*article=(\d+).*?/,'$1')) 
      console.log('move');
    }
  })
}

const member_list = items => {
  const $container = $('.element_list').addClass('is-member').empty()
  items.forEach(item => {
    $(`<a href="${item.href}" class="element_list__member-link">
        <img src="${item.thumb.replace(/\/content1\/up_img\/(staff_[^_]+)_l\.(jpg|jpeg)/i,'/Image/staff/$1_s.jpg')}" alt="${item.title} ${item.desc}" width="350" class="element_list__member-img">
        <p class="element_list__member-name">
          <small>${item.desc.split('|')[1].replace(/^\s|\s$/m,'')}</small>
          <strong>${item.title}</strong>
        </p>
      </a>`).appendTo( $container )
  })
}

const article_info = (items,id) => {
  const detailTitle = document.querySelector('.detail_title');
  if (detailTitle) {
    detailTitle.remove();
  }
  items = items.filter(item => item.id == id)
  if(items.length != 0){
    const name = {
      title: items[0].desc.split('|')[1].replace(/^\s|\s$/m,''),
      name: items[0].title,
      name_en: items[0].desc.split('|')[0].replace(/^\s|\s$/m,''),
      job: items[0].desc.split('|')[2].replace(/^\s|\s$/m,'')
    }
    $('.element_detail,body').addClass('is-member')
    $('.imgbox,.detailImgbox').append(`
      <p class="title">${name.title}</p>
      <h3 class="name">
        <strong>${name.name}</strong>
        <small>${name.name_en}</small>
      </h3>
      <p class="job">${name.job}</p>
    `)
  }
}

export default function MEMBER() {
  $( init )
}